<template>
  <v-app class="grey">
    <v-main>
      <SideBar />
      <transition name="view">
        <router-view />
      </transition>
    </v-main>
  </v-app>
</template>

<script>
import { NetworkHandler } from "@/pipeline/networkHandler.js";

import NavBar from "@/components/NavBar";
import SideBar from "@/components/SideBar";

export default {
  name: "App",
  async beforeMount() {
    if (this.$store.state.networkHandler == null) {
      this.$store.state.networkHandler = new NetworkHandler(this);
    }

    this.$store.state.isAdmin = await this.$store.state.networkHandler.checkisAdmin();
    
    //https://stackoverflow.com/questions/45867357/vuejs-browser-caching-production-builds
    const versionRequest = await this.$store.state.networkHandler.requestVersion();

    if(versionRequest == null || versionRequest.data == null){
      return;
    }

    const newVersion = versionRequest.data.version;
    const lastVersion = this.$cookies.get("lastVersion");
    if(lastVersion == null || lastVersion != newVersion){
      console.log("Reloading page because of new version")
      this.$cookies.set("lastVersion", newVersion, "1Y")
      window.location.reload()
    }
    
  },
  mounted() {},

  components: {
    NavBar,
    SideBar,
  },
};
</script>

<style>
:root {
  --background-color: "white";
  --topbar-size: 48px;
  --sidebar-width: 90px;
  --worker-size: 45px;
  --resource-group-height: 136px;
  --resource-bar-width: 130px;
  --simulation-button-height: 40px;
  --transition-time: 0.2s;
}

::-webkit-scrollbar {
  width: 0px;
  height: 0px;
}
.swal2-select {
  border-style: solid;
  border-radius: 5px;
  border-width: 2px;
  border-color: black;
}

.swal2-select:focus {
  border-style: solid;
  border-radius: 5px;
  border-width: 2px;
  border-color: black;
}

body {
  background-color: var(--background-color);
  -webkit-touch-callout: none;
  -webkit-user-select: none;
  -khtml-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
  -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
  max-height: 1vh;
}
::-webkit-scrollbar-track {
  background-color: "black";
}

::-webkit-scrollbar-thumb {
  background-color: #d6dee1;
  border-radius: 20px;
  border: 1px solid transparent;
  background-clip: content-box;
}

::-webkit-scrollbar-thumb:hover {
  background-color: #a8bbbf;
}

.swal2-container {
  font-family: Helvetica, sans-serif;
}

.v-main__wrap {
  background-color: var(--background-color);
}

.v-application--wrap {
  background-color: var(--background-color);
}
</style>
<style scoped>
.sidebar-container {
  padding: 0em;
  width: 90px;
  height: 100%;
  float: left;
  position: fixed;
}

.view-enter-active,
.view-leave-active {
  transition: opacity var(--transition-time) ease-in-out, transform var(--transition-time) ease;
  max-height: 1vh;

}
.view-enter-active {
  transition-delay: var(--transition-time);
   max-height: 1vh;

}
.view-enter {
  opacity: 0;
   max-height: 1vh;
}
.view-enter-to {
  opacity: 1;
   max-height: 1vh;
}
.view-leave {
  opacity: 1;
   max-height: 1vh;
}
.view-leave-to {
  opacity: 0;
   max-height: 1vh;
}
</style>
